import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LazyLoadEvent } from 'primeng/api/lazyloadevent';
import { Table } from 'primeng/table';
import { FilterValues } from 'src/app/shared/components/filter/filter.component';
import { EStampService, StampCustomerOrder, StampCustomerOrdersResponse } from 'src/app/core/services/e-stamp.service';
import { ToastService } from 'src/app/core/services/toast.service';

@Component({
    selector: 'app-customer-order-list',
    templateUrl: './customer-order-list.component.html',
    styleUrl: './customer-order-list.component.scss',
    standalone: false
})
export class CustomerOrderListComponent {

  loading = false;
  orders: StampCustomerOrder[] = [];
  orderDetail: any = {};

  showModal: boolean = false;
  @ViewChild('dt') table!: Table;


  constructor(
    private estampService: EStampService,
    private router: Router,
    private toastService: ToastService,
  ) { }

  getStampOrders(event: LazyLoadEvent) {
    Promise.resolve().then(() => this.loading = true);
    const first = event?.first ?? 0;
    const rows = event?.rows ?? this.rows;
    const page = first / rows + 1;
    let startDate: string | null = null;
    let endDate: string | null = null;

    if (this.rangeDates && this.rangeDates.length === 2) {
      startDate = this.formatDate(this.rangeDates[0]);
      endDate = this.formatDate(this.rangeDates[1]);
    }

    const queryParams = {
      page: page,
      limit: rows,
      search: this.searchText,
      // status: this.selectedStatus,
      startDate: startDate,
      endDate: endDate
    }

    this.estampService.getStampOrders(queryParams).subscribe(
      (res: any) => {
        this.loading = false;
        this.orders = res?.data || [];
        this.totalRecords = res?.totalCount || 0;

      },
      (err: any) => {
        this.loading = false;
        console.error('Orders API error:', err);
      }
    );
  }

  closeModal() {
    this.showModal = false;
  }

  navigateStampOrderCreate = () => {
    this.router.navigate(['/customer/estamp/create-customer-order']);
  }


  totalRecords = 0;
  rows = 10;
  searchText: any = '';
  rangeDates: Date[] | null = null;

  onFilterChange(values: FilterValues) {
    this.searchText = values.search;
    this.rangeDates = values.dateRange;
    this.table.reset();
  }

  formatDate(date: Date): string {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date.getDate().toString().padStart(2, '0');
    return `${y}-${m}-${d}`;
  }


  viewOrder(ord: any) {
    const id = ord?._id
    this.estampService.getStampOrderDetail(id).subscribe((res: any) => {
      this.showModal = true;
      this.orderDetail = res?.data;
    },
      () => { });
  }

  protectWithPassword(document: any) {
    console.log('Protect with password:', document);
  }

  selectedFile: File | null = null;
  previewUrl: string | null = null;
  fileError: string = '';
  paymentMode: string = '';


  onFileSelect(event: any) {
    const file = event.target.files[0];

    if (!file) return;

    this.fileError = '';
    this.selectedFile = null;
    this.previewUrl = null;

    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      this.fileError = 'Only JPG, JPEG, & PNG files are allowed';
      return;
    }

    const maxSize = 2 * 1024 * 1024;
    if (file.size > maxSize) {
      this.fileError = 'File must be less than 2MB';
      return;
    }
    this.selectedFile = file;

    if (!this.selectedFile) return;

    const reader = new FileReader();
    reader.onload = () => {
      this.previewUrl = reader.result as string;
    };

    reader.readAsDataURL(this.selectedFile);
  }

  upload: boolean = false;

  uploadFile() {
    if (this.upload) return;
    this.upload = true;
    if (!this.selectedFile || !this.paymentMode) return;

    const payload = {
      orderId: this.orderDetail?._id,
      amount: this.orderDetail?.invoice?.amount,
      paymentMode: this.paymentMode,
      file: this.selectedFile
    }
    this.estampService.paymentSubmit(payload).subscribe((res: any) => {
      this.upload = false
      this.getStampOrders({});
      this.showModal = false;
      this.previewUrl = '';
      this.selectedFile = null;
      this.paymentMode = '';
      this.toastService.showToaster("Success", res?.message, "success");
    }, (err: any) => {
      this.upload = false
    })
  }

  @ViewChild('fileInput') fileInput!: ElementRef;

  removeFile() {
    this.selectedFile = null;
    this.previewUrl = null;
    this.fileError = '';
    this.fileInput.nativeElement.value = '';
  }

}
